import { Box, Container, Typography, useMediaQuery, useTheme } from '@mui/material';
import { psiTokens } from '../theme/psiTheme';

// Shared header used by standalone pages (About, Services, Contact): left
// accent bar, small gradient divider, eyebrow, big title, optional subtitle.
export default function PageHeader({ eyebrow, title, subtitle, titleMaxWidth = '780px' }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        position: 'relative',
        backgroundColor: psiTokens.background.tertiary,
        py: isMobile ? 6 : 8,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: '4px',
          height: '100%',
          background: `linear-gradient(180deg, ${psiTokens.primary.dark}, ${psiTokens.primary.light})`,
        }}
      />
      <Container maxWidth="xl">
        <Box
          sx={{
            width: '40px',
            height: '3px',
            background: `linear-gradient(90deg, ${psiTokens.primary.dark}, ${psiTokens.primary.light})`,
            borderRadius: '2px',
            mb: 2,
          }}
        />
        <Typography
          sx={{
            fontSize: '11px',
            fontWeight: 700,
            letterSpacing: '0.15em',
            textTransform: 'uppercase',
            color: psiTokens.primary.light,
            mb: 2,
          }}
        >
          {eyebrow}
        </Typography>
        <Typography variant="h2" sx={{ color: psiTokens.text.primary, fontWeight: 700, mb: subtitle ? 2 : 0, maxWidth: titleMaxWidth }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography
            sx={{
              fontSize: 'clamp(15px, 2vw, 18px)',
              fontWeight: 400,
              color: psiTokens.text.tertiary,
              lineHeight: 1.7,
              maxWidth: '680px',
            }}
          >
            {subtitle}
          </Typography>
        )}
      </Container>
    </Box>
  );
}
